module.exports = __webpack_public_path__ + "static/media/logo_ingweb_notify.2f618599.svg";